(() => {
  if (window.__newArrivalsBound) return;
  window.__newArrivalsBound = true;

  document.addEventListener('click', (event) => {
    const save = event.target.closest('.na-card__save');
    if (save) {
      event.preventDefault();
      event.stopPropagation();
      save.classList.toggle('is-saved');
      return;
    }

    const plus = event.target.closest('.weekly-selection .quick-size-add__plus');
    if (plus) {
      const card = plus.closest('.na-card');
      const hasSizes = card?.querySelector('.quick-size-add__sizes');
      if (hasSizes && !plus.getAttribute('data-variant-id')) {
        event.preventDefault();
        event.stopPropagation();
        card.classList.toggle('is-sizes-open');
        return;
      }
    }

    document.querySelectorAll('.weekly-selection .na-card.is-sizes-open').forEach((card) => {
      if (!card.contains(event.target)) card.classList.remove('is-sizes-open');
    });

    const swatch = event.target.closest('.na-card__swatch');
    if (!swatch) return;
    event.preventDefault();
    event.stopPropagation();

    const card = swatch.closest('.na-card');
    if (!card) return;

    card.querySelectorAll('.na-card__swatch').forEach((item) => {
      item.classList.toggle('is-active', item === swatch);
    });

    const imageUrl = swatch.getAttribute('data-image');
    const main = card.querySelector('.na-card__img--main');
    if (imageUrl && main instanceof HTMLImageElement) {
      main.src = imageUrl;
      main.removeAttribute('srcset');
    }
  });
})();
